import { LoggingPort } from '../ports'
import {
  createLoggingService,
  LogTransportConsole,
} from '@otto-ec/eprivacy-measures'
import { SERVICE, TEAM } from '../model/contants'
export type { LoggingPort } from '../ports'

const loggers = new Map<string, LoggingPort>()

export const logger: LoggingPort = loggerFor()

export function loggerFor(service: string = SERVICE): LoggingPort {
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
  const logTransport = isLocalhost ? new LogTransportConsole() : undefined

  const cached = loggers.get(service)
  if (cached) {
    return cached
  }
  const newLogger = createLoggingService(TEAM, service, logTransport)
  loggers.set(service, newLogger)
  return newLogger
}
